import { ThunkResult } from '../../../store/configureStore'
import { Actions } from '../available-file-listing/actionCreators'

export const resetFileTypeFilter: ThunkResult<Promise<void>> =
  async (dispatch, getState) => {
    dispatch(Actions.fileTypeFilterReset())
  }

